import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";

import {
  EditOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";
import Create_icon from "../../assets/images/create_icon.png";
import Edit_icon from "../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../assets/images/icons/delete_iconbl.svg";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, DatePicker, Input, Modal, Row, Select, Space, Spin, Switch, Table, Tooltip } from "antd";


const { Option } = Select;

export const Appointments = (props) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: <Tooltip title={t("Contact")}>{t("Contact")}</Tooltip>,
      ellipsis: true,
      dataIndex: "contact",
    },
    {
      title: <Tooltip title={t("Calendar")}>{t("Calendar")}</Tooltip>,
      ellipsis: true,
      dataIndex: "calendar",
    },
    {
      title: <Tooltip title={t("Time")}>{t("Time")}</Tooltip>,
      ellipsis: true,
      dataIndex: "time",
    },
    {
      title: <Tooltip title={t("Day")}>{t("Day")}</Tooltip>,
      ellipsis: true,
      dataIndex: "day",
    },
    {
      title: <Tooltip title={t("Action")}>{t("Action")}</Tooltip>,
      ellipsis: true,
      dataIndex: "action",
    },
  ];

  const data = [
    {
      key: "1",
      contact: <span>Bhavin Patel</span>,
      calendar: <span>Schedule A Viewing</span>,
      time: <span>11 AM</span>,
      day: <span>Thursday 10/08/2020</span>,
      action: (
        <div className="action__btns">
          <div className="image__block">
            <img src={Edit_icon} onClick={() => showModal()} alt="" />
          </div>
          <div className="image__block">
            <img src={Delete_iconbl} alt="" />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      contact: <span>Bhavin Patel</span>,
      calendar: <span>Schedule A Viewing</span>,
      time: <span>11 AM</span>,
      day: <span>Thursday 10/08/2020</span>,
      action: (
        <div className="action__btns">
          <div className="image__block">
            <img src={Edit_icon} onClick={() => showModal()} alt="" />
          </div>
          <div className="image__block">
            <img src={Delete_iconbl} alt="" />
          </div>
        </div>
      ),
    },
  ];

  function onChange(value) {}

  function onSearch(val) {}

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block mb-0">
            <h4 className="workarea__heading mt-0 mb-0">{t("Appointments")}</h4>
            <button className="primary-btn" onClick={showModal}>
              <img src={Create_icon} alt="" /> {t("Create Appointment")}
            </button>
          </div>
        </div>

        <div className="col-md-6 mt-5">
          <p className="font-weight-bold">{t("Calendars")}</p>
          <div className="row">
            <div className="radio__block col">
              <input type="checkbox" id="1" />
              <label for="1"> {t("Engagement")} </label>
            </div>
            <div className="radio__block col">
              <input type="checkbox" id="2" />
              <label for="2"> {t("Cleaning")} </label>
            </div>
            <div className="radio__block col">
              <input type="checkbox" id="3" />
              <label for="3"> {t("Repair")} </label>
            </div>
            <div className="radio__block col">
              <input type="checkbox" id="4" />
              <label for="4"> {t("Wedding")} </label>
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-md-12 mt-4">
          <Table
            className="pendjewelreq__tbl"
            columns={columns}
            dataSource={data}
          />
        </div>

        <Modal
          title={t("Create Appointment")}
          centered
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              {t("Cancel")}
            </Button>,
            <Button key="submit" type="primary" onClick={handleCancel}>
              {t("Submit")}
            </Button>,
          ]}
        >
          <div className="form__fields mt-3 p-0 border-0">
            <div className="row">
              <div className="col-md-6">
                <div className="input__block">
                  <label> {t("Select Date")} </label>
                  <input type="date" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label> {t("Select Calendar")} </label>
                  <Select
                    showSearch
                    className="border__grey"
                    placeholder={t("Select Calendar")}
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="1"> {t("Engagement")} </Option>
                    <Option value="2"> {t("Cleaning")} </Option>
                    <Option value="3"> {t("Repair")} </Option>
                    <Option value="4"> {t("Wedding")} </Option>
                  </Select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label> {t("Select Contact")} </label>
                  <Select
                    showSearch
                    className="border__grey"
                    placeholder={t("Select Contact")}
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="1"> {t("ABC")} </Option>
                    <Option value="2"> {t("John")} </Option>
                    <Option value="3"> {t("XYZ")} </Option>
                    <Option value="4"> {t("User")} </Option>
                  </Select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label> {t("Set Day")} </label>
                  <Select
                    showSearch
                    className="border__grey"
                    placeholder={t("Set Day")}
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="jack"> {t("Thursday")} </Option>
                    <Option value="1"> {t("Friday")} </Option>
                    <Option value="2"> {t("Saturday")} </Option>
                    <Option value="3"> {t("Monday")} </Option>
                    <Option value="4"> {t("Tuesday")} </Option>
                  </Select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label> {t("Set Time")} </label>
                  <Select
                    showSearch
                    className="border__grey"
                    placeholder={t("Set Time")}
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="jack"> 10:00 {t("AM")} </Option>
                    <Option value="2"> 11:00 {t("AM")} </Option>
                    <Option value="1"> 12:00 {t("PM")} </Option>
                    <Option value="3"> 1:00 {t("PM")} </Option>
                    <Option value="4"> 2:00 {t("PM")} </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Appointments);
